// Notion-style trip cover with emoji and gradient background

// Destination to emoji mapping
export const DESTINATION_EMOJI: Record<string, string> = {
  // Japan
  京都: "⛩️",
  東京: "🗼",
  大阪: "🏯",
  沖縄: "🏝️",
  北海道: "🦌",
  札幌: "❄️",
  福岡: "🍜",
  奈良: "🦌",
  神戸: "🌉",
  横浜: "🎡",
  名古屋: "🏰",
  広島: "🕊️",
  金沢: "🍵",
  仙台: "🌸",
  鎌倉: "🎋",
  箱根: "♨️",
  軽井沢: "🌲",
  熱海: "🌊",
  長崎: "⛪",
  鹿児島: "🌋",
  富士山: "🗻",
  日光: "🍁",
  高山: "🏔️",

  // Asia
  ソウル: "🇰🇷",
  Seoul: "🇰🇷",
  韓国: "🇰🇷",
  台北: "🧋",
  Taipei: "🧋",
  台湾: "🧋",
  香港: "🌃",
  "Hong Kong": "🌃",
  シンガポール: "🦁",
  Singapore: "🦁",
  バンコク: "🛕",
  Bangkok: "🛕",
  タイ: "🐘",
  バリ: "🌺",
  Bali: "🌺",
  ベトナム: "🍜",
  ハノイ: "🍜",
  ホーチミン: "🛵",
  上海: "🏙️",
  Shanghai: "🏙️",
  北京: "🐉",
  Beijing: "🐉",
  中国: "🐼",

  // Europe
  パリ: "🗼",
  Paris: "🗼",
  フランス: "🥐",
  ロンドン: "🇬🇧",
  London: "🇬🇧",
  イギリス: "☕",
  ローマ: "🏛️",
  Rome: "🏛️",
  イタリア: "🍕",
  バルセロナ: "⚽",
  Barcelona: "⚽",
  スペイン: "💃",
  アムステルダム: "🌷",
  Amsterdam: "🌷",
  プラハ: "🏰",
  Prague: "🏰",
  ウィーン: "🎻",
  Vienna: "🎻",
  ベルリン: "🐻",
  Berlin: "🐻",
  ドイツ: "🍺",
  スイス: "🏔️",
  ギリシャ: "🏛️",

  // Americas & Oceania
  ニューヨーク: "🗽",
  "New York": "🗽",
  ロサンゼルス: "🎬",
  "Los Angeles": "🎬",
  サンフランシスコ: "🌉",
  "San Francisco": "🌉",
  ハワイ: "🌺",
  Hawaii: "🌺",
  ラスベガス: "🎰",
  "Las Vegas": "🎰",
  シドニー: "🦘",
  Sydney: "🦘",
  オーストラリア: "🐨",
  メルボルン: "☕",
  Melbourne: "☕",
  ニュージーランド: "🥝",
  カナダ: "🍁",

  // Middle East & Others
  ドバイ: "🏙️",
  Dubai: "🏙️",
  モルディブ: "🏝️",
  Maldives: "🏝️",
  カンクン: "🌴",
  Cancun: "🌴",
  メキシコ: "🌮",
  エジプト: "🏺",
  トルコ: "🕌",
  インド: "🕌",
};

// Interest to emoji mapping
export const INTEREST_EMOJI: Record<string, string> = {
  sightseeing: "📸",
  観光: "📸",
  food: "🍽️",
  グルメ: "🍽️",
  nature: "🌿",
  自然: "🌿",
  culture: "🎭",
  文化: "🎭",
  shopping: "🛍️",
  ショッピング: "🛍️",
  adventure: "🏄",
  アドベンチャー: "🏄",
  relaxation: "🧘",
  リラクゼーション: "🧘",
  寺社仏閣: "⛩️",
  和菓子: "🍡",
  ビーチ: "🏖️",
  マリンスポーツ: "🤿",
  温泉: "♨️",
  スキー: "⛷️",
  登山: "🥾",
  アート: "🎨",
  音楽: "🎵",
  歴史: "📜",
};

// Gradient options with display names (for picker UI)
export const GRADIENT_OPTIONS = [
  { id: "from-rose-400 to-orange-300", name: "Sunset" },
  { id: "from-fuchsia-500 to-pink-400", name: "Fuchsia" },
  { id: "from-violet-500 to-purple-400", name: "Violet" },
  { id: "from-indigo-500 to-blue-400", name: "Indigo" },
  { id: "from-cyan-400 to-teal-400", name: "Cyan" },
  { id: "from-emerald-400 to-green-400", name: "Emerald" },
  { id: "from-lime-400 to-emerald-400", name: "Lime" },
  { id: "from-yellow-400 to-orange-400", name: "Amber" },
  { id: "from-amber-400 to-yellow-300", name: "Gold" },
  { id: "from-sky-400 to-cyan-300", name: "Sky" },
  { id: "from-blue-400 to-indigo-400", name: "Ocean" },
  { id: "from-purple-400 to-pink-400", name: "Grape" },
];

// Gradient class names only (for internal use)
export const GRADIENTS = GRADIENT_OPTIONS.map((g) => g.id);

// Popular emojis for trip covers (deduplicated)
export const EMOJI_OPTIONS = [
  // Travel & Places
  "✈️",
  "🗺️",
  "🧳",
  "🎒",
  "🏖️",
  "🏝️",
  "🏔️",
  "🗻",
  "🌋",
  "🏕️",
  "🏜️",
  "🌅",
  "🌄",
  "🌊",
  "🌴",
  "🌲",
  // Buildings & Landmarks
  "🏯",
  "🏰",
  "⛩️",
  "🗼",
  "🗽",
  "🕌",
  "🛕",
  "⛪",
  "🏛️",
  "🎡",
  "🎢",
  "🎪",
  "🌉",
  "🏙️",
  "🌃",
  "🌆",
  // Transport
  "🚗",
  "🚕",
  "🚌",
  "🚂",
  "🚀",
  "🛳️",
  "⛵",
  "🚁",
  "🛵",
  "🚲",
  "🛶",
  "🚡",
  "🚠",
  "🚃",
  "🛫",
  // Food & Drink
  "🍽️",
  "🍜",
  "🍣",
  "🍕",
  "🍔",
  "🌮",
  "🥐",
  "🍝",
  "🍱",
  "🍛",
  "🥘",
  "🍲",
  "🧋",
  "🍷",
  "🍺",
  "☕",
  // Activities
  "🏄",
  "🤿",
  "🎿",
  "⛷️",
  "🏂",
  "🧗",
  "🥾",
  "🎣",
  "🏊",
  "🚴",
  "⛺",
  "🎭",
  "🎨",
  "📸",
  "🎵",
  "🛍️",
  // Nature & Animals
  "🌸",
  "🌺",
  "🌻",
  "🍁",
  "🦌",
  "🐘",
  "🦁",
  "🐼",
  "🦘",
  "🐨",
  "🦋",
  "🌈",
  "⭐",
  "🌙",
  "☀️",
  "❄️",
  // Symbols
  "🎌",
  "🏳️",
  "🎏",
  "🎐",
  "💫",
  "✨",
  "💎",
  "🔮",
  "🎯",
  "🧭",
  "🗿",
  "⚓",
  "🏴‍☠️",
  "🚩",
];

/**
 * Calculate a hash value from a string for consistent selection
 */
function hashString(str: string): number {
  return str.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
}

/**
 * Get emoji for a trip based on destination and interests
 */
export function getTripEmoji(destination: string, interests: string[] = []): string {
  // Try exact destination match
  if (DESTINATION_EMOJI[destination]) {
    return DESTINATION_EMOJI[destination];
  }

  // Try partial destination match
  for (const [key, emoji] of Object.entries(DESTINATION_EMOJI)) {
    if (destination.includes(key) || key.includes(destination)) {
      return emoji;
    }
  }

  // Fall back to first interest
  if (interests.length > 0) {
    for (const interest of interests) {
      if (INTEREST_EMOJI[interest]) {
        return INTEREST_EMOJI[interest];
      }
    }
  }

  // Default emoji
  return "✈️";
}

/**
 * Get gradient background class for a trip
 */
export function getTripGradient(destination: string): string {
  const hash = hashString(destination);
  return GRADIENTS[hash % GRADIENTS.length];
}

export interface TripCover {
  emoji: string;
  gradient: string;
}

/**
 * Get complete cover information for a trip
 */
export function getTripCover(destination: string, interests: string[] = []): TripCover {
  return {
    emoji: getTripEmoji(destination, interests),
    gradient: getTripGradient(destination),
  };
}
